import { ref, watchEffect } from 'vue'
import { useResetPasswordMutation } from '@server/graphql/mutations/resetPasswordMutation'
import { IResetPasswordInput, IResetPasswordResponse, IFetchResetPasswordReturn } from '@types'

/**
 * Função para executar a mutação de redefinição de senha.
 * @param resetPasswordInput As variáveis necessárias para a mutação.
 * @returns Um objeto com referências reativas para os dados, estado de carregamento, erros e função de parada.
 */
const mutateResetPassword = (
  resetPasswordInput: IResetPasswordInput
): IFetchResetPasswordReturn => {
  const data = ref<IResetPasswordResponse | null>(null)
  const loading = ref<boolean>(false)
  const error = ref<Error | null>(null)
  const { mutate, onDone, onError } = useResetPasswordMutation()

  const execute = async () => {
    loading.value = true
    try {
      await mutate({ resetPasswordInput })
    } catch (err) {
      error.value = err as Error
    }
  }

  const stop = watchEffect(() => {
    onDone(({ data: mutationData }) => {
      data.value = mutationData?.resetPassword.payload.message
      loading.value = false
    })

    onError(mutationError => {
      error.value = mutationError as Error
      loading.value = false
    })
  })

  return { execute, data, loading, error, stop }
}

export default mutateResetPassword
